import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ImageWithDefault } from "../../Layout/Common/imageWithDefault";
import { GlobalContext } from "../../Context/GlobalContext";
import { isValidArray, normalizeUrlPath } from "../../Layout/Common/common";
import { PAGES } from "../../routeConfig";

export const BrandListContainer = () => {
  const [brand, setBrand] = useState(null);
  const { brandList } = useContext(GlobalContext);
  useEffect(() => {
    if (brandList) {
      setBrand(brandList);
    }
  }, [brandList]);

  return (
    <section className="products-section">
      <div className="container-fluid container-lg">
        <div className="row">
          <div className="col-md-12">
            <div className="section-title">
              <h2>Top Brands</h2>
              <Link to={PAGES.BRAND} className="text-decoration-underline text-uppercase">
                View All
              </Link>
            </div>
          </div>
        </div>
        <div className="row brandingList-row">
          {isValidArray(brand) &&
            brand.map((item, index) => (
              <div className="col-4 col-md-2" key={index}>
                <div className="branding-list branding-listHome">
                  <Link
                    to={PAGES.BRAND + "/" + normalizeUrlPath(item.name)}
                    className="brand-list-effect"
                    style={{ margin: "auto" }}
                  >
                    <ImageWithDefault src={item.imageUrl} alt="brand list" />
                  </Link>
                </div>
                <div className="product-code" style={{ width: "100%", textAlign: "center" }}>
                  {item.name}
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};
